module.exports = __webpack_public_path__ + "img/favicon.bc94f0af.png";